export { default } from './cannabinoids-view';
